import { useUI } from '../../context/UIContext';

// Only the accent dot colour is used per type — the toast shows a coloured dot,
// not an icon. (Previously carried unused emoji `icon` fields; removed.)
const TYPE_STYLES = {
  success: { border: '#4a6b3f' },
  error:   { border: '#9a564a' },
  warning: { border: '#8a6a1f' },
  info:    { border: '#b8973a' },
};

export default function Toast() {
  const { toasts, removeToast } = useUI();

  if (!toasts.length) return null;

  // Lifted clear of the bottom-right corner, which the help bubble owns.
  return (
    <div className="fixed bottom-[88px] right-6 z-[9999] flex flex-col gap-2.5 pointer-events-none">
      {toasts.map((toast) => {
        const s = TYPE_STYLES[toast.type] || TYPE_STYLES.info;
        return (
          <div
            key={toast.id}
            className="pointer-events-auto flex items-start gap-3 px-4 py-3 rounded-xl text-[13px] font-medium text-white max-w-[360px] shadow-2xl animate-[slideUp_.3s_ease]"
            style={{ background: '#08111f', border: '1px solid rgba(255,255,255,0.08)' }}
          >
            <span className="flex-shrink-0 w-2 h-2 rounded-full mt-[5px]" style={{ background: s.border }} />
            <span className="flex-1 leading-snug">{toast.message}</span>
            <button
              onClick={() => removeToast(toast.id)}
              className="flex-shrink-0 text-white/40 hover:text-white/80 transition-colors text-[16px] leading-none mt-px"
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
}
